/* eslint-disable max-len */

export const REFERRAL_TRACKING = {
  viewInviteEarnPage: 'View Invite and Earn Page',
  clickReferralCallbackRequest: 'Click Referral Callback Request',
  clickReferralGoodiesPDF: 'Click Referral Goodies PDF',
  viewRewardsTable: 'View Rewards Table',
  clickKnowMoreOnBanner: 'View Rewards CTA',
  viewWhoToReferComponent: 'View Who can I refer',
  viewWaysToReferComponent: 'View Ways to refer',
  viewRewardsCalc: 'View Rewards Calc',
  sliderChangeRewardsCalc: 'Click slider bar',
  clickReferBtnRewardsCalc: 'Click Referral Callback Request',
  clickRewardsCalcBtn: 'Click Rewards Calculator',
  clickReferalBtnBanner: 'Click Referral Callback Request',
  clickCopyReferralCode: 'Click Copy Referral Code',
  clickCopyReferralCodeOnReferModal: 'Click Copy Referral Code',
  clickSocialShare: 'Click Whatsapp Social Share',
  clickRequestTextOnWhatsApp: 'Click Request text on whatsapp',
  clickReferralFaq: 'Click Referral FAQ',
  clickReferralPolicy: 'Click Referral Policy',
  viewReferralStepCards: 'View Referral Step Cards',
  viewMenteeRewardsTable: 'View Mentee Rewards Table',
  viewReferralTestimonial: 'View Referral Testimonial',
  viewFriendsRewards: 'View Friends Rewards',
  viewReferModal: 'View Refer Modal',
  viewHowToRefer: 'View How To Refer',
  viewRmContactModal: 'View Show Contact modal',
  clickShowContactModal: 'Click Show Contact modal',
  viewWhyToRefer: 'View Why to refer',
  clickIWantACallBack: 'Click I want a Call Back',
  clickShowContactNumber: 'Click Show Contact Number',
  clickAddFriendDetails: 'Click Add Friend Details',
  clickReferralFaqTnc: 'Click Here terms and condition',
  clickToOpenBankDetails: 'Click to add bank details',
  viewEntryExitPopupModal: 'View Entry Exit Popup Modal',
  clickStoreIcon: 'Click store icon',
  viewFriendSuccessModal: 'View Friend Success Modal',
  clickRequestCallback: 'Click Request a Callback',
  clickCheckStatus: 'Click Check Status',
  viewFriendDetailsModal: 'View Friend Details Modal',
  clickNextButton: 'Click Next Button',
  clickCancelButton: 'Click Cancel Button',
  clickEditButton: 'Click Edit Button',
  clickDeleteButton: 'Click Delete Button',
  clickSubmitButton: 'Click Submit Button',
  clickAddAnotherButton: 'Click Add Another Button',
  viewDummyPage: 'Dummy Page View',
  clickDummyCalculator: 'Dummy Calc',
  clickDummyTalkToReferralManager: 'Dummy Talk to Referral Manager',
  clickDummyViewRewards: 'Dummy View Rewards',
  clickDummyPostRCBClose: 'Dummy Close',
  viewTestimonials: 'View Referral Testimonials',
  clickTestimonialsLinkedIn: 'Click LinkedIn Button On Testimonials',
  viewWaysToReferBanner: 'View Ways To Refer Banner',
  clickConnectNow: 'Click Connect Now',
  clickReferNow: 'Click Refer Now',
  viewConsentModal: 'View Consent Modal',
  clickSubmitConsent: 'Submit Consent Modal',
  closeConsentModal: 'Close Consent Modal',
  viewConsentSuccessModal: 'View Consent Success Modal',
  closeConsentSuccessModal: 'Close Consent Success Modal',
  clickDiwaliRcb: 'Click Diwali Campaign RCB Button',
  clickReferralTermsAndConditions: 'Click Diwali Terms and Conditions',
  clickKnowMore: 'Click Know more on a call',
  clickTodoListRewardsCalculator: 'Click Rewards Calculator in Todo List',
  clickTodoListRequestCallback: 'Click Request Callback in Todo List',
  clickTodoListBankAccountDetails: 'Click Bank Account Details in Todo List',
  clickTodoListHowReferralWorks: 'Click How Referral Works in Todo List',
  viewPostRefundJourneyIntro: 'View Post Refund Journey Intro',
  viewPostRefundJourneyHowItWorks: 'View Post Refund Journey How It Works',
  viewPostRefundJourneyRewardsCalculator: 'View Post Refund Journey Rewards Calculator',
  viewPostRefundJourneyRequestCallback: 'View Post Refund Journey Request Callback',
  clickPostRefundJourneyRequestCallback: 'Click Post Refund Journey Request Callback',
  clickPostRefundJourneyDoLater: 'Click Post Refund Journey Do Later',
  viewSuccessStoriesTestimonialSection: 'View Success Stories Testimonial Section',
  clickSuccessStoriesTestimonialScroll: 'Click Event on Testimonials Scroll',
  acknowledgementModalView: 'Referral Acknowledgement Modal View',
  userPreferredProgramSelectedClick: 'User Preferred Program Selected Click',
};
